import React, { Component } from "react";
// import { Notification, TextInputSkeleton } from "carbon-components-react";
import Modal from "@acadia-ui/modal";
import "carbon-components/scss/components/notification/_inline-notification.scss";
import { onStateChange } from "events";
import ErrorHelpers from "../../Components/FormBuilder/ErrorHelpers";
import FormBuilderV2 from "../../Components/FormBuilder/FormBuilderV2";
import { editPackages } from "../../Flux/Actions/PackagesActions";
import UpdateStateHelper from "../../Components/FormBuilder/UpdateStateHelper";
import ModalHelpers from "./ModalHelpers";
import PackagesDataStore from "../../Flux/Stores/PackagesDataStore";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import "./modal.scss";
import ParentDataStore from "../../Flux/Stores/ParentDataStore";
import moment from "moment";
import Loading from "../../Components/LoadingSpinner";
import PlacementDataStore from "../../Flux/Stores/PlacementDataStore";
import Button from "@acadia-ui/button";
import { ToastNotification, showToast, TOAST_TYPE } from "@acadia-ui/toast";
import Heading, { HEADING_LEVEL, HEADING_SIZE } from "@acadia-ui/heading";

const initialState = {
	formData: {},
	postData: {},
	errors: {},
	showErrors: false,
	valueToCalculate: "plannedTotalCost",
	isFormDataValid: false,
	isFormTouched: false
};

const formEl = "edit_package";

class EditPackage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			metaData: {
				StartDate: moment(this.props.metaData.StartDate).format("YYYY/MM/DD"),
				EndDate: moment(this.props.metaData.EndDate).format("YYYY/MM/DD")
			},
			loading: false,
			...initialState
		};
	}

	componentDidMount() {
		this.props.editPackage(this);
		PackagesDataStore.on("edit_fail", this.handleErrors);
		PackagesDataStore.on("package__errors__reset", this.handleReset);
		PackagesDataStore.on("edit_success", this.checkIfPlacement);
		PackagesDataStore.on("edit_success_placement_fail", this.placementUpdateError);
		PlacementDataStore.on("packages_loaded_refresh", this.placementRefreshed);
	}

	componentDidUpdate(prevProps) {
		this.isValidFormData();
	}

	componentWillUnmount() {
		this.props.editPackage(undefined);
		PackagesDataStore.removeListener("edit_fail", this.handleErrors);
		PackagesDataStore.removeListener("package__errors__reset", this.handleReset);
		PackagesDataStore.removeListener("edit_success", this.checkIfPlacement);
		PackagesDataStore.removeListener("edit_success_placement_fail", this.placementUpdateError);
		PlacementDataStore.removeListener("packages_loaded_refresh", this.placementRefreshed);
	}

	placementRefreshed = async () => {
		if (this.state.open === true) {
			await this.props.refresh();
			await this.props.updateCounts("Package");
			this.triggerOpenClose(null, true); // pass true here, don't wait for loading state to change.
			setTimeout(() => {
				this.setState({ loading: false }); // delay loading reset to next render cycle to avoid flicker
			}, 0);
		}
	};

	placementUpdateError = () => {
		this.setState({ loading: false }, () => {
			showToast(
				"workbookToasts",
				<ToastNotification type={TOAST_TYPE.ERROR} message="The package was updated but there was an error with updating placements. Please check your placements." />
			);
			this.triggerOpenClose();
			this.props.refresh();
			this.props.updateCounts("Package");
		});
	};

	closePlacementError = () => {
		this.setState({ placementErrorModalOpen: false }, () => {
			this.setState({ loading: false }, () => {
				this.triggerOpenClose();
				this.props.refresh();
				this.props.updateCounts("Package");
			});
		});
	};

	checkIfPlacement = () => {
		if (!this.props.tabNames.includes("Placement")) {
			this.handleSuccess();
		} else if (this.props.packageData !== undefined) {
			this.props.updatePlacementsWithPackages(this.props.packageData.PackageID);
		}
		showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="Package updated successfully." timed={8000} />);
	};

	handleSuccess = async () => {
		await this.props.updateCounts("Package");
		await this.props.refresh();
		this.triggerOpenClose(null, true); // pass true here, don't wait for loading state to change.
		setTimeout(() => {
			this.setState({ loading: false }); // delay loading reset to next render cycle to avoid flicker
		}, 0);
	};

	handleErrors = () => {
		this.setState({ loading: false }, () => {
			const errors = PackagesDataStore.getErrors();
			// console.log('errors from store', errors);
			if (Object.keys(errors).length > 0) {
				const placementErrors = errors;
				const type = "edit package";
				this.setState({ errors: placementErrors, showErrors: true }, () => {
					// console.log(this.state);
					ErrorHelpers.displayErrors(formEl, this.state.errors, type);
					showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.ERROR} message="Package could not be updated. Please try again." />);
				});
			}
		});
	};

	/* Needed for all Modals */
	triggerOpenClose = (event, force = false) => {
		if (this.state.loading === false || force) {
			ModalHelpers.openClose(event, this.updateModalState, this.state, initialState, () => {
				ErrorHelpers.resetErrors(formEl);
				if (!this.state.open) {
					const modals = document.getElementsByClassName("bx--modal-content");
					if (this.props.config) {
						const fieldCount =
							this.props.config.PackageData.filter((field) => {
								return field.FieldType !== "Hidden";
							}).length +
							this.props.config.TaxonomyData.filter((field) => {
								return field.FieldType !== "Hidden";
							}).length +
							this.props.config.MetaData.filter((field) => {
								return field.FieldType !== "Hidden";
							}).length;
						if (modals) {
							if (fieldCount <= 8) {
								for (const modal of modals) {
									if (modal.style.overflow !== "visible") {
										modal.style.overflow = "visible";
									}
								}
							} else {
								for (const modal of modals) {
									if (modal.style.overflow !== "auto") {
										modal.style.overflow = "auto";
									}
								}
							}
						}
					}

					this.setState({ loading: true }, () => {
						this.fillFields();
					});
				}
			});
		}
	};

	fillFields = () => {
		if (this.props.packageData !== undefined) {
			this.setState({ postData: { PackageData: { PackageID: this.props.packageData.PackageID } }, loading: false }, () => {
				this.matchData();
			});
		}
	};

	matchData = () => {
		this.handleReset();
		const configObjs = Object.entries(this.props.config);
		const dataFieldsArray = [];
		for (const dataBucket of configObjs) {
			if (dataBucket[0] !== "ParentData" && dataBucket[0] !== "ChildData") {
				for (const field of dataBucket[1]) {
					if (this.props.packageData !== undefined) {
						if (this.props.packageData.hasOwnProperty(field.Name)) {
							if (field.DataType === "Select") {
								let optionID = this.props.packageData[`${field.Name}ID`];
								let fieldLabel = this.props.packageData[field.Name];
								const fieldItem = dataBucket[1].filter((a) => a.Name == field.Name);

								if (fieldItem.length > 0) {
									const optionItem = fieldItem[0].Options.filter((a) => a.OptionLabel == this.props.packageData[field.Name]);
									if (optionItem.length > 0) {
										optionID = optionItem[0].OptionID;
									}
								}

								if (optionID === undefined) {
									let dataValueID = null;
									const previousTaxonomyData =
										this.props.packageData.TaxonomyData && this.props.packageData.TaxonomyData !== "" ? JSON.parse(this.props.packageData.TaxonomyData) : [];
									const previousMetaData =
										this.props.packageData.MetaData && this.props.packageData.MetaData !== "" ? JSON.parse(this.props.packageData.MetaData) : [];
									previousTaxonomyData.forEach((taxonomyField) => {
										if (taxonomyField.DataKeyShortDescr === field.Label) {
											if (taxonomyField.DataValue) {
												dataValueID = taxonomyField.DataValue.DataValueID;
											}
										}
									});
									if (dataValueID === null) {
										previousMetaData.forEach((metaDataField) => {
											if (metaDataField.DataKeyShortDescr === field.Label) {
												if (metaDataField.DataValue) {
													dataValueID = metaDataField.DataValue.DataValueID;
												}
											}
										});
									}
									if (dataValueID !== null) {
										const changedMatchingOption = field.Options.filter((option) => option.OptionID === dataValueID.toString());
										if (changedMatchingOption[0] !== undefined) {
											optionID = changedMatchingOption[0].OptionID;
											fieldLabel = changedMatchingOption[0].OptionLabel;
										}
									}
								}

								// Populate Drop Down Fields
								// There are only 7 Parameters accepted: see updateState below to match
								if (optionID != undefined && optionID > 0) {
									dataFieldsArray.push([dataBucket[0], field.Name, { value: optionID, label: fieldLabel }, field.ID, field.DataType, false, false]);
									// this.updateState(
									// 	dataBucket[0],
									// 	field.Name,
									// 	{ value: optionID, label: this.props.packageData[field.Name] },
									// 	field.ID,
									// 	field.DataType,
									// 	false,
									// 	false
									// );
								}
							} else {
								// Populate Free Text Fields
								// There are only 7 Parameters accepted: see updateState below to match
								dataFieldsArray.push([dataBucket[0], field.Name, this.props.packageData[field.Name], field.ID, field.DataType, false, false]);
								// this.updateState(
								// 	dataBucket[0],
								// 	field.Name,
								// 	this.props.packageData[field.Name],
								// 	field.ID,
								// 	field.DataType,
								// 	false,
								// 	false
								// );
							}
						}
					}
				}
			}
		}
		setTimeout(() => {
			this.updateStatev2(dataFieldsArray);
		}, 100);
	};

	updateModalState = () => {
		this.setState({ open: !this.state.open, ...initialState });
	};
	/* END */

	isValidFormData = () => {
		const { formData } = this.state;
		let isValid = true;
		for (const key in formData) {
			if (Object.hasOwn(formData, key)) {
				const { value } = formData[key];
				const isDisabled = formData[key].disabled;
				if (["Rate", "Cost", "PlannedUnits"].includes(key) && ["Flat", "Free", "Added Value"].includes(formData.RateType?.value?.label)) {
					if ((value === "" || value == null || value == undefined) && !isDisabled) {
						isValid = false;
					} else {
						continue;
					}
				}
				if ((value == "" || value == null || value == undefined || value == "0.00") && !isDisabled) {
					isValid = false;
				}
			}
		}

		if (this.state.isFormDataValid !== isValid) {
			this.setState({ isFormDataValid: isValid });
		}
	};

	updateState = (dataConfig, name, value, id, dataType, calc, disabled) => {
		if (this.state.loading === false) {
			this.setState({ isFormTouched: true });
			UpdateStateHelper.update(dataConfig, name, value, id, dataType, calc, formEl, this, disabled, this.props.config, false, this.isValidFormData());
		}
	};

	updateStatev2 = (dataFieldsArray) => {
		if (this.state.loading === false) {
			UpdateStateHelper.updatev2(dataFieldsArray, formEl, this, this.props.config);
		}
	};

	handleReset = () => {
		ErrorHelpers.resetErrors(formEl);
	};

	sortTaxonomyData = (taxonomyData) => {
		const taxDataWithPositions = taxonomyData;
		taxDataWithPositions.forEach((taxonomyField) => {
			if (this.props.config.TaxonomyData) {
				this.props.config.TaxonomyData.forEach((taxFieldConfig) => {
					if (taxFieldConfig.ID === taxonomyField.dataKeyID) {
						taxonomyField.Position = taxFieldConfig.Position;
					}
				});
			}
		});
		taxDataWithPositions.sort((a, b) => {
			if (a.Position < b.Position) {
				return -1;
			}
			if (a.Position > b.Position) {
				return 1;
			}
			return 0;
		});
		taxDataWithPositions.forEach((taxonomyField) => {
			delete taxonomyField.Position;
		});
		return taxDataWithPositions;
	};

	/* This should be a helper object that formats POST JSON for the PUT Actions */
	formDataObjForPost = (newRowObj) => {
		if (Object.keys(newRowObj).length > 0) {
			const postData = { ...this.state.postData };
			let strippedTaxonomyPostData = [];

			/* Removes the Key from the Taxonomy Data Array : Theja's Post does not like it */
			for (const i in postData.TaxonomyData) {
				strippedTaxonomyPostData.push(postData.TaxonomyData[i]);
			}
			strippedTaxonomyPostData = this.sortTaxonomyData(strippedTaxonomyPostData);

			const strippedMetadataPostData = [];
			for (const i in postData.MetaData) {
				strippedMetadataPostData.push(postData.MetaData[i]);
			}
			postData.MetaData = strippedMetadataPostData;

			/* postData is a copy of the state, so we just overwrite the innards with our new array */
			postData.TaxonomyData = strippedTaxonomyPostData;
			const filters = BookFiltersStore.getChoicesState();
			const campaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();
			postData.PackageData.CampaignID = this.props.packageData.CampaignID;
			postData.PackageData.MasterCampaignID = this.props.packageData.MasterCampaignID;
			postData.PackageData.UniqueID = this.props.packageData.UniqueID;
			if (this.props.metaData.Budget === null || this.props.metaData.Budget === 0) {
				postData.PackageData.Cost = 0;
			}
			// const MasterUniqueCodeID = MasterCampaignsStore.getMasterUniqueID();
			/* Config will hold the ID's of the filters */
			const PlatformID = filters.platform.value;
			const AuditLevelID = this.props.auditLevelID;
			// const auditlevelID = filters.auditlevel.value;
			const contextValues = BookFiltersStore.getContextValues();
			const formSubmissionObj = {
				MasterAgencyDivisionName: contextValues?.agency?.name,
				MasterBusinessUnitName: contextValues?.client?.name,
				MasterCountryCode: contextValues?.country?.name,
				ContextID: contextValues.contextId,
				PlatformID,
				AuditLevelID,
				MasterRegionCode: contextValues?.region?.name,
				CampaignUniqueIDCode: campaignUniqueID,
				...postData
			};

			formSubmissionObj.PackageData.PackageType = this.props.packageData?.PackageType;
			// console.log(formSubmissionObj);
			return [formSubmissionObj];
		}
		this.setState({ errors: { Errors: ["Please fill in all form fields."] }, showErrors: true }, () => {
			ErrorHelpers.displayErrors(formEl, this.state.errors);
		});
	};

	sendPostObject = (newRowObj) => {
		this.postObject = this.formDataObjForPost(newRowObj);
		let row = null;
		PackagesDataStore.getData().forEach((pack, index) => {
			if (pack.PackageID === this.props.packageData.PackageID) {
				row = index;
			}
		});

		if (this.postObject) {
			editPackages(this.postObject, false, row);
		}

		if (this.postObject === undefined) {
			this.setState({ loading: false });
		}
	};

	handleSubmit = (e) => {
		if (this.state.loading === false) {
			this.setState({ loading: true }, () => {
				e.preventDefault();
				/* Server Side Validation */
				this.sendPostObject(this.state.formData);
			});
		}
	};

	updateCalculatedField = (value) => {
		this.setState({ valueToCalculate: value });
	};

	enableSubmit = () => {
		if (this.state.isFormTouched && this.state.isFormDataValid === true) {
			return false;
		}
		return true;
	};

	render() {
		/* Temp Test Function -- Loads a skeleton if nothing there yet */
		// const filters = BookFiltersStore.getChoicesState();
		let formInnards;
		if (this.props.config) {
			if (Object.keys(this.props.config).length !== 0) {
				const isDraft = Boolean(this.props.packageData && this.props.packageData.IsDraft === "True");
				formInnards = (
					<FormBuilderV2
						type="edit package"
						data={this.props.config}
						configName="packagesConfig"
						onUpdate={this.updateState}
						state={this.state}
						isDraft={isDraft}
						updateCalculatedField={this.updateCalculatedField}
						formEl={formEl}
						parentRef={this}
						metaData={this.props.metaData}
						auditLevelID={this.props.auditLevelID}
						syncStatus={this.props.packageData?.ExternalSystemStatusID}
					/>
				);
			} else {
				formInnards = <div></div>;
			}
		}

		return (
			<>
				<Modal
					id={formEl}
					className="create--package"
					heading="Edit Package"
					description="You can make edits inline, then click the 'Save' button to save the changes."
					isOpen={this.state.open}
					onRequestClose={() => {
						if (this.state.open) {
							this.triggerOpenClose();
						}
					}}
					size="medium"
					userClosable={true}
					onClick={() => {}}
					actionSetProps={{
						actionsRight: (
							<>
								<Button className="first-button" display="secondary" onClick={this.triggerOpenClose} data-tracking-id-alt="cancel-edit-package">
									Cancel
								</Button>
								<Button
									className="third-button"
									display="primary"
									disabled={this.enableSubmit()}
									onClick={this.handleSubmit}
									data-tracking-id-alt="confirm-edit-package"
								>
									Save
								</Button>
							</>
						)
					}}
				>
					{this.state.loading && <Loading className="modalLoading" />}
					<Heading as={HEADING_LEVEL.H2} size={HEADING_SIZE.EXTRA_SMALL} className="placement-count">
						Child placement count: {this.props.packageData?.ChildCount || 0}
					</Heading>
					<form autoComplete="off">
						<div className="form__group__container _m-t--10 _m-b--10">{formInnards}</div>
						{this.state.showErrors && <div id="errors__container" />}
					</form>
				</Modal>
			</>
		);
	}
}

export default EditPackage;
